{
    "LoadingLabel": "[A atualizar...]",
    "NAME": "ComboBox"
}